module.exports = __webpack_public_path__ + "assets/img/10.30a6f268.png";